import Icons, { IconsProps } from '../../Icons';

export type LoadingProps = IconsProps;

export function Loading(props: LoadingProps) {
  return (
    <Icons {...props}>
      <path d="M11 20.9C8.7 20.6667 6.79167 19.696 5.275 17.988C3.75833 16.2793 3 14.2667 3 11.95C3 9.63333 3.75833 7.629 5.275 5.937C6.79167 4.24567 8.7 3.26667 11 3V4.225C9.05 4.50833 7.43333 5.375 6.15 6.825C4.86667 8.275 4.225 9.98333 4.225 11.95C4.225 13.9167 4.86667 15.625 6.15 17.075C7.43333 18.525 9.05 19.3917 11 19.675V20.9ZM13 20.9V19.675C14.7667 19.4417 16.2583 18.704 17.475 17.462C18.6917 16.2207 19.4417 14.7167 19.725 12.95H20.95C20.75 15.0667 19.9043 16.871 18.413 18.363C16.921 19.8543 15.1167 20.7 13 20.9ZM19.725 10.95C19.475 9.18333 18.7333 7.679 17.5 6.437C16.2667 5.19567 14.7667 4.45833 13 4.225V3C15.1333 3.2 16.9417 4.04167 18.425 5.525C19.9083 7.00833 20.75 8.81667 20.95 10.95H19.725Z" />
    </Icons>
  );
}
